<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";
import Field from "./Field.vue";

export interface SelectOption { value: string; label: string }

const props = withDefaults(
  defineProps<{
    modelValue?: string;
    options?: (string | SelectOption)[];
    label?: string;
    hint?: string;
    error?: string;
    id?: string;
  }>(),
  { options: () => [] },
);
defineEmits<{ "update:modelValue": [string] }>();

const normalised = computed<SelectOption[]>(() =>
  props.options.map((o) => (typeof o === "string" ? { value: o, label: o } : o)),
);
const wrapped = computed(() => Boolean(props.label ?? props.hint ?? props.error));
</script>
<template>
  <component
    :is="wrapped ? Field : 'div'"
    v-bind="wrapped ? { label, hint, error, htmlFor: id } : { style: 'display:contents' }"
  >
    <div class="cw-select">
      <select
        :id="id"
        class="cw-select__el"
        :value="modelValue"
        @change="$emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
      >
        <option
          v-for="opt in normalised"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.label }}
        </option>
      </select>
      <Icon
        name="chevron-down"
        :size="17"
        class="cw-select__chev"
      />
    </div>
  </component>
</template>
